import { memo } from 'react'

import type { IUploadPrimitiveProps } from './upload-primitive.types'
import { UploadPrimitiveView } from './upload-primitive.view'

const Component = ({ children }: IUploadPrimitiveProps) => {
  return <UploadPrimitiveView>{children}</UploadPrimitiveView>
}

export const UploadPrimitive = memo(Component)
